interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="https://public.readdy.ai/ai/img_res/8279267b-0350-43cd-a9ea-6dcf0521fa28.png" 
            alt="VALIDE d.o.o. Logo" 
            className="h-10 w-auto mr-3"
          />
          <span className={`text-lg font-medium transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            VALIDE d.o.o.
          </span>
        </div>
        
        <div className="flex items-center space-x-10">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-sm font-medium transition-all duration-200 hover:text-teal-500 relative group whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white/90'
            }`}
          >
            Home
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
          </button>
          <button
            onClick={() => scrollToSection('products')}
            className={`text-sm font-medium transition-all duration-200 hover:text-teal-500 relative group whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white/90'
            }`}
          >
            Products
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-all duration-200 hover:text-teal-500 relative group whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white/90'
            }`}
          >
            About
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium transition-all duration-200 hover:text-teal-500 relative group whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white/90'
            }`}
          >
            Contact
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
          </button>
        </div>
      </div>
    </nav>
  );
}